import React, { useEffect, useRef, useState } from 'react'
import i18next from 'i18next'
import { useNavigate } from 'react-router'
import { getQueryParams } from '../utils/UtilityFunctions'
import { Container, Grid, Typography, Button, Box , Accordion , AccordionSummary, AccordionDetails} from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import imgurl from '../assests/images/imgurl';
import LanguageSelector from '../LanguageSelector';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';

const StartTest = () => {

  const navigate = useNavigate()
  const [showFixedButton, setShowFixedButton] = useState(false);
  const mainRef = useRef(null);
  const locale = useSelector((state) => state.language.langData);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, []);

  useEffect(() => {
    let params = getQueryParams(window.location.href)
    // console.log("params>>>", params, window.location.href.split('#')[1].split('/')[1].split('?')[0]);
    if(params?.params?.gender && params.params.gender) {
      localStorage.setItem('gender', params.params.gender)
    } else {
      localStorage.setItem('gender', 'male')
    }
    localStorage.setItem('channel', 'alopexia-before-signup')
    navigate('/tutorial')
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = window.innerHeight;
      // Show button after scrolling 20% of div height
      const scrolledPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;
      console.log("scrolledPercent", scrolledPercent);
      if (scrolledPercent > 10) {
        setShowFixedButton(true);
      } else {
        setShowFixedButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [])

  return (
    <div className='startTestPage' ref={mainRef}>
      
    </div>
  )
}

export default StartTest